const newsHero = () => {
  function calcBannerPostBgWidth() {
    let elPostLeft = document.querySelector(".news-hero");
    const elLeftBackground = document.querySelector(".hero-bg");

    if (elPostLeft != null) {
      elPostLeft = elPostLeft.getBoundingClientRect().left; // The distance (length) of div from the left of screen
      elLeftBackground.style.left = "-" + elPostLeft + "px";
    }
  }
  const container = document.querySelector(".content-with-sidebar");
  if (container != null && container.classList.contains("news")) {
    calcBannerPostBgWidth();
    window.addEventListener(
      "resize",
      () => {
        calcBannerPostBgWidth();
      },
      true
    );
  }
};

export default newsHero;
